const storageEventKey = {
	MORGAN_PRICE_PAYMENT_ACCEPTED: 'MORGAN_PRICE_PAYMENT_ACCEPTED',
	MORGAN_PRICE_PAYMENT_CANCELLED: 'MORGAN_PRICE_PAYMENT_CANCELLED',
	MORGAN_PRICE_PAYMENT_DECLINED: 'MORGAN_PRICE_PAYMENT_DECLINED',
	MORGAN_PRICE_PAYMENT_EXCEPTION: 'MORGAN_PRICE_PAYMENT_EXCEPTION',

	DECLARATION_STATE: 'DECLARATION_STATE',
	MORGAN_PRICE_PAYMENT_IN_PROCESSING: 'MORGAN_PRICE_PAYMENT_IN_PROCESSING',
	MORGAN_PRICE_PAYMENT_TAB_CLOSE: 'MORGAN_PRICE_PAYMENT_TAB_CLOSE',
}

export default storageEventKey
